// The app's strings for the shared i18next runtime (@todo/core/i18n/runtime):
// bundled, so translations resolve synchronously during the static render.

import { getInstanceForLocale, initI18n } from '@todo/core/i18n/runtime';

import en from './resources/en.json';
import es from './resources/es.json';
import ru from './resources/ru.json';

const i18n = initI18n({
  en: { translation: en },
  es: { translation: es },
  ru: { translation: ru },
});

export { getInstanceForLocale };
export default i18n;
